import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getApiUsages(options={}) {
	return _apiRequestWrap(
		ModulesMap.API_USAGES,
		ModulesConfigMap[ModulesMap.API_USAGES].GET_API_USAGES,
		options
	)
}

function _getApiUsage(options={}) {
	return _apiRequestWrap(
		ModulesMap.API_USAGES,
		ModulesConfigMap[ModulesMap.API_USAGES].GET_API_USAGE,
		options
	)
}

function _getApiUsagePreview(options={}) {
	return _apiRequestWrap(
		ModulesMap.API_USAGES,
		ModulesConfigMap[ModulesMap.API_USAGES].GET_API_USAGE_PREVIEW,
		options
	)
}

function _getApiUsagePopup(options={}) {
	return _apiRequestWrap(
		ModulesMap.API_USAGES,
		ModulesConfigMap[ModulesMap.API_USAGES].GET_API_USAGE_POPUP,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.API_USAGES].GET_API_USAGES]: _getApiUsages,

	[ModulesConfigMap[ModulesMap.API_USAGES].GET_API_USAGE]: _getApiUsage,
	[ModulesConfigMap[ModulesMap.API_USAGES].GET_API_USAGE_PREVIEW]: _getApiUsagePreview,
	[ModulesConfigMap[ModulesMap.API_USAGES].GET_API_USAGE_POPUP]: _getApiUsagePopup,

}